<template>
  <section-layout
    :showButton="false"
  >
    <template v-slot:title>
      {{localization.tabsTitles.informeSoporteDocumental}}
    </template>
    <template v-slot:content>
      <v-expansion-panels
        v-model="panel" id="panel"
        multiple
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            <o-medium-title class="pr-5">
              {{localization.filtros.title}}
            </o-medium-title>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <filtrosInformeSoporteDocumental
              tipo="informeSoporteDocumental"
              :disabled="loading"
              @aplicar="aplicarFiltros"
              @borrar="borrarFiltros"
              :itramit="true"
            />
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

    </template>
  </section-layout>
</template>

<script>
import { mapActions } from 'vuex'
import filtrosInformeSoporteDocumental from './filtrosInformeSoporteDocumental'
import mixinExcel from '@/mixins/downloadExcel'

export default {
  mixins: [mixinExcel],
  components: {
    filtrosInformeSoporteDocumental
  },
  data () {
    return {
      loading: false,
      tableSearch: '',
      incidencias: [],
      loader: null,
      panel: [0]
    }
  },
  computed: {
    localization () {
      return this.$t('sectionInformes')
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      getDocumentos: 'informes/getDocumentos'
    }),
    async aplicarFiltros (values) {
      try {
        this.loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false,
          onCancel: this.onCancel,
        })
        this.loading = true
        this.getDocumentos(values)
          .then(e => {
            this.loading = false
            console.log(e)
            var nombre = e.data.nombreFichero
            var binario = atob(e.data.zip)
            var array = []
            for (var i = 0; i < binario.length; i++) {
              array.push(binario.charCodeAt(i))
            }
            var blob = new Blob([new Uint8Array(array)], { type: 'application/zip' })
            if (window.navigator.msSaveBlob) {
              window.navigator.msSaveOrOpenBlob(blob, nombre)
            } else {
              var a = window.document.createElement('a')
              a.href = window.URL.createObjectURL(blob, { type: 'application/zip' })
              a.download = nombre
              document.body.appendChild(a)
              a.click()
              document.body.removeChild(a)
            }
            this.loader.hide()
          })
          .catch(e => {
            this.loading = false
            this.loader.hide()
            this.addAlert({ texto: e.data.mensaje || this.$t('errorCargaDeDatos'), color: 'error' })
          })
        // let csv = await this.getDocumentos(values)
        // this.downloadExcel(csv.file || csv.data)
      } catch (error) {
        console.log('ERROR AL CARGAR DATOS? descarga', error)
        this.addAlert({ texto: this.$t('errorCargaDeDatos'), color: 'error' })
      }
      this.loading = false
    },
    borrarFiltros () {
      this.incidencias = []
    }
  }
}
</script>
